import { Pipe, PipeTransform } from '@angular/core';
import { BasketStatus } from '@sabstravtech/obtservices/angular';

@Pipe({
  name: 'basketStatusPipe',
  standalone: false
})
export class BasketStatusPipe implements PipeTransform {
  transform(value: string): string {
    if (value === BasketStatus.Disapproved) {
      return 'Declined';
    } else {
      return value;
    }
  }
}
